<div [formGroup]="formGeneralDetails">
  <h2>General Details</h2>
  <div class="general-details__container general-details__container--with-wizard-buttons">
    <p class="general-details__info">General information such as name, address etc.</p>

    <div class="general-details__entityType">
      <mat-label>Entity Type</mat-label>
      <mat-radio-group formControlName="entityType" (change)="onEntityChange($event.value)" aria-label="Select an option">
        <mat-radio-button [value]="NewAccountEntityType.Company">Company</mat-radio-button>
        <mat-radio-button [value]="NewAccountEntityType.Person">Person</mat-radio-button>
        @if (
          formGeneralDetails.controls.entityType.invalid &&
          (formGeneralDetails.controls.entityType.dirty || formGeneralDetails.controls.entityType.touched)
        ) {
          <mat-error> You must select an entity type</mat-error>
        }
      </mat-radio-group>
    </div>
    @if (showCompanyFields) {
      <div class="general-details__grid">
        <div>
          <mat-form-field>
            <mat-label>Account Name</mat-label>
            <mat-icon matSuffix matTooltip="The name the Company is commonly known by (may be the same as Official Name)." matTooltipPosition="above"
              >help_outline</mat-icon
            >
            <input matInput formControlName="accountName" />
            <mat-error> Required</mat-error>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field>
            <mat-label>Official Name</mat-label>
            <mat-icon
              matSuffix
              matTooltip="The official registered company name. This is the name which must appear on all licence documentation."
              matTooltipPosition="above"
              >help_outline</mat-icon
            >
            <input matInput formControlName="officialName" />
            <mat-error> Required</mat-error>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field>
            <mat-label>Trading as Name</mat-label>
            <mat-icon
              matSuffix
              matTooltip="For a non-limited company, the Trading As (T/A) name. If applicable, this must also appear on licence documentation."
              matTooltipPosition="above"
              >help_outline</mat-icon
            >
            <input matInput formControlName="tradeName" />
          </mat-form-field>
        </div>

        @if (isPrs) {
          <div>
            <mat-form-field>
              <mat-label>Previous Trading as Name</mat-label>
              <input matInput formControlName="prevTradeName" />
            </mat-form-field>
          </div>

          <div>
            <mat-form-field>
              <mat-label>Select Organistation Type</mat-label>
              <mat-select title="Organisation Type" formControlName="orgType" (selectionChange)="orgTypeChange($event.value)">
                <mat-option>--</mat-option>
                @for (organistationType of organisationTypes; track organistationType) {
                  <mat-option [value]="organistationType.key"> {{ organistationType.value }} </mat-option>
                }
              </mat-select>
              <mat-error>Required</mat-error>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field>
              <mat-label>Registration Number </mat-label>
              <input matInput formControlName="regNumber" />
              @if (formGeneralDetails.controls['regNumber'].hasError('pattern')) {
                <mat-error>This is a required field and it should start with CHY</mat-error>
              }
              @if (formGeneralDetails.controls['regNumber'].hasError('required')) {
                <mat-error
                  >This is a required field
                  @if (isCharity) {
                    <span> and it should start with CHY</span>
                  }
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
    }
    <div class="general-details__grid">
      <div>
        <mat-form-field>
          <mat-label>Select Salutation</mat-label>
          <mat-select title="Standard select" formControlName="salutation">
            <mat-option>--</mat-option>
            @for (salutation of salutations; track salutation) {
              <mat-option [value]="salutation.value"> {{ salutation.value }} </mat-option>
            }
          </mat-select>
          <mat-error>Required</mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>First Name</mat-label>
          <input matInput formControlName="firstName" />
          <mat-error> Required</mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="lastName" />
          <mat-error> Required</mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Email address</mat-label>
          <mat-icon
            matSuffix
            matTooltip="This email address will used for correspondence regarding licences/permits and for the management of your eLicensing account."
            matTooltipPosition="above"
            >help_outline</mat-icon
          >
          <input matInput formControlName="email" [readonly]="emailIsReadOnly" />
          <mat-error comFormMessageName="email" validation="required">Required</mat-error>
          <mat-error comFormMessageName="email" validation="pattern">The email format is incorrect</mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Phone</mat-label>
          <input matInput formControlName="phone" />
          <mat-error> Required</mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Mobile</mat-label>
          <input matInput formControlName="mobile" />
        </mat-form-field>
      </div>

      @if (accountType === NewAccountType.Radio) {
        <div>
          <mat-label>Document Preferences</mat-label>
          <div>
            <mat-radio-group formControlName="docPrefDeliveryMethod" ngDefaultControl aria-label="Select an option">
              <mat-radio-button value="1">Electronic</mat-radio-button>
              <mat-radio-button value="0">Paper</mat-radio-button>
            </mat-radio-group>
            <mat-radio-group formControlName="docPrefLanguage" ngDefaultControl aria-label="Select an option">
              <mat-radio-button value="0">English</mat-radio-button>
              <mat-radio-button value="1">Irish</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      }
    </div>

    <div class="general-details__grid">
      <div>
        <mat-form-field>
          <mat-label>Address Line 1</mat-label>
          <input matInput formControlName="addressLine1" />
          <mat-error> Required</mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Address Line 2</mat-label>
          <input matInput formControlName="addressLine2" />
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Address Line 3</mat-label>
          <input matInput formControlName="addressLine3" />
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Address Line 4</mat-label>
          <input matInput formControlName="addressLine4" />
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Postcode</mat-label>
          <input matInput formControlName="postCode" />
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Select county</mat-label>
          <mat-select title="Standard select" formControlName="county">
            <mat-option>--</mat-option>
            @for (county of counties; track county) {
              <mat-option [value]="county.value"> {{ county.value }} </mat-option>
            }
          </mat-select>
          <mat-error>Required</mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Select country</mat-label>
          <mat-select (selectionChange)="countryChanged($event.value)" title="Standard select" formControlName="country">
            <mat-option>--</mat-option>
            @for (country of countries; track country) {
              <mat-option [value]="country.name"> {{ country.name }} </mat-option>
            }
          </mat-select>
          <mat-error>Required</mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
